// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Olá {{first_name}}, de que precisa para {{restaurant}}?',
  title_no_name: 'Olá, do que precisa para {{restaurant}}?',
  text: 'Posso responder a perguntas sobre {{restaurant}} e fazer alterações por si. Nada muda sem a sua aprovação.',
  suggestions: 'Sugestões',
  // No restaurant selected (D18): Amigo asks which restaurant; the prompts let it ask for the restaurant's name.
  no_restaurant: {
    title: 'Olá {{first_name}}, para que restaurante é?',
    title_no_name: 'Olá, para que restaurante é?',
    text: 'Indique o restaurante na sua mensagem e eu trato disso, sem o abrir primeiro. Nada muda até o aprovar.',
    prompts: {
      sunday_hours: 'Alterar o horário de domingo de um restaurante para as 12:00–21:00',
      close_several: 'Fechar vários restaurantes a 24 de dezembro',
    },
  },
  prompts: {
    reports: {
      top_dishes: 'Quais foram os 10 pratos mais vendidos no mês passado?',
      sales_vs_last_month: 'Como evoluíram as vendas face ao mês passado?',
    },
    menu: {
      raise_dish_price: 'Aumentar o preço de {{dish}} em {{amount}}',
      dish_sold_out: 'Marcar {{dish}} como esgotado',
      dishes_without_photo: 'Que pratos não têm foto?',
    },
    hours: {
      holiday_hours: 'Alterar o nosso horário de funcionamento para 24 de dezembro',
    },
    order_settings: {
      minimum_order: 'Aumentar o pedido mínimo para {{amount}}',
    },
    marketing: {
      promo_code: 'Criar um código promocional de 10 % para este fim de semana',
    },
    my_info: {
      phone_number: 'Atualizar o nosso número de telefone',
    },
  },
};
